<!-- ============================================================================= -->
<!-- Ella Custom JS - Customize The Style For Layout -->
<!-- ============================================================================= -->

<!-- ============================================================================= -->
<!-- IMPORTANT DISCLAIMER -->
<!-- Please use only JS to style the layout. -->
<!-- ============================================================================= -->

document.addEventListener("DOMContentLoaded", function() {
    // Selecciona todos los elementos de precio en el carrito
    const priceElements = document.querySelectorAll('.price.price--end[data-item-final-price-display]');
    const quantityInputs = document.querySelectorAll('.form-input.quantity.cart-item-qty-input');

    // Función para actualizar el precio unitario
    function updateUnitPrice() {
        priceElements.forEach(priceElement => {
            const cartItem = priceElement.closest('.cart-item');
            const quantityInput = cartItem.querySelector('.form-input.quantity.cart-item-qty-input');
            const subtotalElement = cartItem.querySelector('.cart-item-value[data-item-price-with-quantity-display]');

            if (subtotalElement && quantityInput) {
                const subtotalText = subtotalElement.innerText.replace(/[^\d.,-]/g, '').replace(',', '.');
                const subtotal = parseFloat(subtotalText);
                const quantity = parseInt(quantityInput.value, 10);

                if (!isNaN(subtotal) && !isNaN(quantity) && quantity > 0) {
                    const unitPrice = (subtotal / quantity).toLocaleString('es-ES', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
                    priceElement.innerText = `€${unitPrice}`;
                } else {
                    priceElement.innerText = 'N/A';
                }
            }
        });
    }

    // Llama a la función para actualizar el precio unitario al cargar la página
    updateUnitPrice();

    // Agrega un event listener a cada input de cantidad para actualizar el precio unitario
    quantityInputs.forEach(input => {
        input.addEventListener('change', updateUnitPrice);
    });
});
